/// <reference path="../../app.definition.ts" />

import angular from 'angular';


export let placeElement = (el: any, relEl: any, offset: Offset, placement: string, parent?: string, compile?: Function, scope?: any, width?, height?): void => {
    if (!!el && !!el[0]) {
        el.remove().appendTo(angular.element('body'));
        let elSize = new ElementSize(width || el[0].offsetWidth, height || el[0].offsetHeight);
        el.remove();

        // el.css('width', 'auto');
        let par: JQuery<HTMLElement> = !!parent ? angular.element(parent) : null;

        // console.log("RelativeTo:", relEl, "Element:", el);
        let relElSize = elementSize(relEl);
        let relElOffset = getOffset(relEl);
        if (!!par) {
            let parOffset = getOffset(par);
            relElOffset.top = relElOffset.top - parOffset.top;
            relElOffset.left = relElOffset.left - parOffset.left;
        }

        let top: number = relElOffset.top + offset.top;
        let left: number = relElOffset.left + offset.left;

        switch (placement) {
            case Placements.RIGHT:
                top += (relElSize.outerHeight - elSize.outerHeight) / 2;
                left += relElSize.outerWidth;
                break;
            case Placements.LEFT:
                top += (relElSize.outerHeight - elSize.outerHeight) / 2;
                left -= elSize.outerWidth;
                break;
            case Placements.BOTTOM:
                top += relElSize.outerHeight;
                left += (relElSize.outerWidth - elSize.outerWidth) / 2;
                break;
            case Placements.TOP:
            default:
                top -= elSize.outerHeight;
                left += (relElSize.outerWidth - elSize.outerWidth) / 2;
                break;
        }

        if (left < 0) {
            left = 5;
        } else if (!!par && (left + elSize.outerWidth) > par.width()) {
            left = par.width() - elSize.outerWidth - 5;
        }
        if (top <= 0) {
            top = 3;
        } else if (!!par && (top + elSize.outerHeight) > par.height()) {
            top = par.height() - elSize.outerHeight - 3;
        }
        offset = new Offset(left, top);
        // console.log("Placing element(", el, elSize, offset, ") positioned to the", placement, "of relative element(", relEl, relElSize, relElOffset, ")")

        el.css({ position: 'absolute', top: top, left: left, width: elSize.outerWidth });
        if (!!par) {
            par.css('position') == 'static' && par.css('position', 'relative');
            el.appendTo(par);
        } else {
            el.appendTo(angular.element('body'));
        }
        !!compile && !!scope && (compile(el)(scope));

        // if (!!arrow) {
        //     let arrowEl = angular.element(`<div class="message-arrow message-arrow-$DIR"></div>`.replace(/\$DIR/g, placement));
        //
        //     !!arrow.color && (arrowCss['border-' + placement + '-color'] = arrow.color);
        //     el.append(arrowEl);
        // }
    }
}

export let getOffset = ($el: JQuery<HTMLElement>, $anch?: JQuery<HTMLElement>): Offset => {
    let elOff = $el.offset() || new Offset();
    let anchOff = !!$anch ? $anch.offset() : new Offset();
    return new Offset(elOff.left - anchOff.left, elOff.top - anchOff.top);
}

export let getPosition = ($el: ng.IAugmentedJQuery, $anch?: ng.IAugmentedJQuery): Offset => {
    let elOff = $el.position() || new Offset();
    let anchOff = !!$anch ? $anch.position() : new Offset();
    return new Offset(elOff.left - anchOff.left, elOff.top - anchOff.top);
}

// export const origin = new Offset(0,0);
export let cssString = (css: any): string => Object.entries(css).map(c => c[0] + ":" + c[1]).join(';');

export const Placements: any = {
    CENTER: 'center',
    TOP: 'top',
    LEFT: 'left',
    RIGHT: 'right',
    BOTTOM: 'bottom',
    TOP_RIGHT: 'top-right',
    BOTTOM_RIGHT: 'bottom-right',
    TOP_LEFT: 'top-left',
    BOTTOM_LEFT: 'bottom-left'
}

export class Sides {
    top: number;
    left: number;
    right: number;
    bottom: number;
    unit: string;

    constructor(top: number, right?: number, bottom?: number, left?: number, unit?: string) {
        if (!right && right != 0) {
            this.top = this.left = this.right = this.bottom = top || 0;
        } else if (!!right && !bottom && bottom != 0) {
            this.top = this.bottom = top || 0;
            this.right = this.left = right || 0;
        } else if (!left && left != 0) {
            this.top = top || 0;
            this.right = this.left = right || 0;
            this.bottom = bottom || 0;
        } else {
            this.top = top || 0;
            this.left = left || 0;
            this.right = right || 0;
            this.bottom = bottom || 0;
        }

        this.unit = unit || 'px'
    }

    toCssString(): string {
        let str = this.top + this.unit + ' ' + this.right + this.unit;
        if (this.top != this.bottom)
            str += ' ' + this.bottom + this.unit;
        if (this.left != this.right)
            str += ' ' + this.left + this.unit;
        return str;
    }
}


export class Corners {
    topLeft: number;
    topRight: number;
    bottomRight: number;
    bottomLeft: number;
    unit: string;

    constructor(topLeft: number, topRight?: number, bottomRight?: number, bottomLeft?: number, unit?: string) {
        if (!topRight && topRight != 0) {
            this.topLeft = this.bottomLeft = this.topRight = this.bottomRight = topLeft;
        } else if (!!topRight && !bottomRight && bottomRight != 0) {
            this.topLeft = this.bottomRight = topLeft;
            this.topRight = this.bottomLeft = topRight;
        } else if (!bottomLeft && bottomLeft != 0) {
            this.topLeft = topLeft;
            this.topRight = this.bottomLeft = topRight;
            this.bottomRight = bottomRight;
        } else {
            this.topLeft = topLeft;
            this.bottomLeft = bottomLeft;
            this.topRight = topRight;
            this.bottomRight = bottomRight;
        }

        this.unit = unit || 'px';
    }

    toCssString(): string {
        let str = this.topRight + this.unit + ' ' + this.topLeft + this.unit;
        if (this.topLeft != this.bottomRight)
            str += ' ' + this.bottomRight + this.unit;
        if (this.bottomLeft != this.topRight)
            str += ' ' + this.bottomLeft + this.unit;
        return str;
    }
}


export class Coords {
    x: number;
    y: number;
    constructor(x?: number, y?: number) {
        this.x = x || 0;
        this.y = y || 0;
    }
}

export class Offset {
    left: number;
    top: number;
    constructor(left?: any, top?: number) {
        if (!!left && !!left.offset && !!left.offset()) {
            this.left = left.offset().left;
            this.top = left.offset().top;
        } else {
            this.left = left || 0;
            this.top = top || 0;
        }
    }

    shiftLeft = (shift: number): void => {
        this.left += shift || 0;
    }

    shiftTop = (shift: number): void => {
        this.top += shift || 0;
    }
}

export class ElementSize {
    innerHeight: number;
    innerWidth: number;
    outerHeight: number;
    outerWidth: number;

    constructor(outerWidth?: any, outerHeight?: number, innerWidth?: number, innerHeight?: number) {
        // console.log("Element:", outerWidth,":", typeof outerWidth);
        if (!!outerWidth && typeof outerWidth.innerWidth == 'function') {
            this.innerWidth = outerWidth.innerWidth();
            this.innerHeight = outerWidth.innerHeight();
            this.outerWidth = outerWidth.outerWidth();
            this.outerHeight = outerWidth.outerHeight();
        } else {
            this.outerWidth = outerWidth || 0;
            this.outerHeight = outerHeight || 0;
            this.innerWidth = innerWidth || this.outerWidth;
            this.innerHeight = innerHeight || this.outerHeight;
        }
    }
}

export class ElementBox {
    offset: Offset;
    size: ElementSize;
    elements: ng.IAugmentedJQuery[];
    relativeTo: JQuery<HTMLElement>;

    constructor(elements: any, relativeTo?: ng.IAugmentedJQuery) {
        if (!!elements && elements instanceof Array) {
            this.elements = elements || [];
        } else {
            this.elements = !!elements ? [elements] : []
        }

        this.relativeTo = relativeTo || $(document);

        if (this.elements.length > 1) {
            let bbox = getBoundingBox(this.elements, this.relativeTo);
            this.offset = bbox.offset;
            this.size = bbox.size;
        } else {
            this.offset = getOffset(this.elements[0], this.relativeTo);
            this.size = elementSize(this.elements[0]);
        }
    }
}

export let elementSize = (el: any): ElementSize => {
    return new ElementSize($(el));
}

export let windowSize = (): ElementSize => {
    return new ElementSize($(window));
}

export let documentSize = (): ElementSize => {
    return new ElementSize($(document));
}

//Taken from
var keys = { 37: 1, 38: 1, 39: 1, 40: 1 };

function preventDefault(e) {
    e = e || window.event;
    if (e.preventDefault)
        e.preventDefault();
    e.returnValue = false;
}

function preventDefaultForScrollKeys(e) {
    if (keys[e.keyCode]) {
        preventDefault(e);
        return false;
    }
}

export function haltScroll(el: string) {
    disableScroll();
    disableOverflow(el);
}
export function resumeScroll(el: string) {
    enableScroll();
    enableOverflow(el);
}

export function disableOverflow(el: any) {
    if (typeof el == 'string') {
        el = angular.element(el);
    }

    let over: any = {};

    !!el.css('overflow') && (over['overflow'] = el.css('overflow'));
    !!el.css('overflow-x') && (over['overflow-x'] = el.css('overflow-x'));
    !!el.css('overflow-y') && (over['overflow-y'] = el.css('overflow-y'));
    el[0].overflow = over;

    el.css('overflow', 'hidden');
    // console.log("Overflow", over, "stored and disabled for", el);
}

export function enableOverflow(el: any) {
    if (typeof el == 'string') {
        el = angular.element(el);
    }

    let over = angular.copy(el[0].overflow);

    if (!!over) {
        el.css(over);
        delete el[0]['overflow'];
    }

    // console.log("Overflow", over, "restored for", el);

}

export function disableScroll() {

    if (window.addEventListener) // older FF
        window.addEventListener('DOMMouseScroll', preventDefault, false);
    window.onwheel = preventDefault; // modern standard
    // window.onmousewheel = document.onmousewheel = preventDefault; // older browsers, IE
    window.ontouchmove = preventDefault; // mobile
    document.onkeydown = preventDefaultForScrollKeys;
}

export function enableScroll() {
    if (window.removeEventListener)
        window.removeEventListener('DOMMouseScroll', preventDefault, false);
    // window.onmousewheel = document.onmousewheel = null;
    window.onwheel = null;
    window.ontouchmove = null;
    document.onkeydown = null;
}

export let saveEventHandlers = (el: any, eventName?: string): void => {
    let target = typeof el == 'string' ? jQuery(el) : el;
    let events = !!target[0] && jQuery._data(target[0], 'events');
    // console.log("Saving events for", target, "Event Names", events);
    if (!!events) {
        target[0].event_name = [];
        target[0].event_handler = [];
        // console.log("Saving events for", target);
        angular.element.each(events, function (event_name, event_handler) {
            if (!eventName || event_name == eventName) {
                target[0].event_name.push(event_name);
                var _handlers = [];
                for (var i = 0; i < event_handler.length; i++) {
                    _handlers.push(event_handler[i].handler);
                }
                target[0].event_handler.push(_handlers);
                // console.log("Saved Event:", event_name, "Handlers:", event_handler);
            }
        });
        !!eventName && target.off(eventName) || target.off();
    }
}

export let restoreEventHandlers = (el: any, eventName?: string): void => {
    let target: any = angular.element(el);
    let restored = [];
    if (!!target[0]) {
        for (var i = 0; i < (target[0].event_handler || []).length; i++) {
            if (!eventName || eventName == target[0].event_name[i]) {
                // console.log("Restoring event for", target, "Event:", target[0].event_name[i], "Handlers", target[0].event_handler[i]);
                for (var ii = 0; ii < (target[0].event_handler[i] || []).length; ii++) {
                    target.on(target[0].event_name[i], target[0].event_handler[i][ii]);
                }
                restored.push(i);
            }
        }

        for (let i = 0; i < restored.length; i++) {
            !!target[0].event_name[restored[i]] && target[0].event_name.splice(restored[i]);
            !!target[0].event_handler[restored[i]] && target[0].event_handler.splice(restored[i]);
        }
    }
}


// go through a list of elements to find the offset and size of the
// smallest rectangle that will contain all elements
export let getBoundingBox = (elements: any[], anchor?: any): { size: ElementSize, offset: Offset } => {
    let $anchor = !!anchor ? angular.element(anchor) : null;
    // console.log("Anchor:", $anchor, anchor);
    let frame: { size: ElementSize, offset: Offset } = null;
    for (let el of elements) {
        let $el;
        if (typeof el == 'string') {
            $el = el == 'window' ? $(window) : el == 'document' ? $(document) : angular.element(el);
        }
        // console.log('Element:', $el, el, $el.innerHeight());
        let elSize = elementSize($el);
        let elOff = getOffset($el, $anchor);
        // console.log("Element '" + el + "': size =", elSize, " offset =", elOff);
        if (!frame) {
            frame = {
                size: elSize,
                offset: elOff
            }
        } else {
            let offset = new Offset(Math.min(frame.offset.left, elOff.left), Math.min(frame.offset.top, elOff.top));
            let w = Math.max(frame.size.outerWidth, (elOff.left + elSize.outerWidth) - offset.left);
            let h = Math.max(frame.size.outerHeight, (elOff.top + elSize.outerHeight) - offset.top);
            let size = new ElementSize(w, h);

            frame = { offset: offset, size: size };
        }
        // console.log("current frame:", frame);
    }
    return frame;
}
